import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import apiClient from "../api/apiClient";
import Select from "react-select";

const OrdersUpdateLines = () => {
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [error, setError] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [itemOld, setitemOld] = useState("");
    const [itemNew, setitemNew] = useState("");
    const [project, setproject] = useState("");
    const [serviceType, setServiceType] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [items, setItems] = useState([]);
    const [projects, setProjects] = useState([]);

     // Obtener la lista de artículos desde el backend
    const fetchItems = async () => {
        try {
            const response = await apiClient.get("/sales-orders/items");
            const responsePro = await apiClient.get("/sales-orders/projects");
            
            if (!Array.isArray(response.data)) {
                throw new Error("Los datos recibidos no son un array");
            }
            // Formatear los artículos para el select
            const formattedItems = response.data.map((item) => ({
                value: item.ItemCode,
                label: `${item.ItemCode} - ${item.ItemName}`,
            }));
            setItems(formattedItems);

            if (!Array.isArray(responsePro.data)) {
                throw new Error("Los datos recibidos no son un array");
            }
            // Formatear los Proyectos para el select
            const formattedProjects = responsePro.data.map((item) => ({
                value: item.PrjCode,
                label: `${item.PrjName}`,
            }));
            setProjects(formattedProjects);

        } catch (err) {
            console.error("Error obteniendo artículos", err);
            setError("Error al obtener los artículos.");
        }
    };

    // Función para obtener datos desde el backend
    const fetchOrders = async () => {
        try {
            const response = await apiClient.get("/sales-orders/update-items", {
                params: { startDate, endDate, itemOld: itemOld?.value || "", itemNew: itemNew?.value || "", project: project?.value || "" }
            });

            console.log("Datos recibidos:", response.data);

            if (!Array.isArray(response.data)) {
                throw new Error("Los datos recibidos no son un array");
            }

            // Aplicar agrupación según la opción seleccionada
            const groupedData = response.data.reduce((acc, order) => {
                let key;
                    key = `${order.DocEntry}`;


                if (!acc[key]) {
                    acc[key] = {
                        DocEntry: order.DocEntry,
                        SN: order.CardName,
                        Institucion: order.Name,
                        FecElab: order.DocDueDate,
                        Orders: [],
                    };
                }
                acc[key].Orders.push(order);
                return acc;
            }, {});

            const formattedData = Object.values(groupedData);
            setOrders(formattedData);
            setFilteredOrders(formattedData);
        } catch (err) {
            console.error("Error fetching orders", err);
            setError("Error al obtener órdenes de ventas.");
        }
    };
    
    // 🔍 Filtrado dinámico
    useEffect(() => {
        fetchItems();
        if (!searchTerm) {
            setFilteredOrders(orders);
            return;
        }

        const filteredData = orders.filter((order) =>
            (order.CardName ? order.CardName.toLowerCase() : "").includes(searchTerm.toLowerCase()) || 
            (order.Name ? order.Name.toLowerCase() : "").includes(searchTerm.toLowerCase())
        );

        setFilteredOrders(filteredData);
    }, [searchTerm, orders]);

    // Componente expandible para mostrar líneas de orden
    const ExpandedComponent = ({ data }) => (
        <div className="p-2">
            <h6 style={{ fontSize: "12px" }}>Detalles de la Orden</h6>
            <table className="table table-sm table-bordered" style={{ fontSize: "10px" }}>
                <thead>
                    <tr>
                        <th>Insumo</th>
                        <th>Descripción</th>
                        <th>Reemplazo</th>
                        <th>Cantidad</th>
                        <th>Proyecto</th>
                    </tr>
                </thead>
                <tbody>
                    {data.Orders.map((order, index) => (
                        <tr key={index}>
                            <td>{order.ItemCode}</td>
                            <td>{order.Dscription}</td>
                            <td>{order.Reemplazo}</td>
                            <td>{order.Quantity}</td>
                            <td>{order.Project}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

    const columns = [
        {
            name: "Socio de Negocios",
            selector: (row) => row.SN,
            sortable: true,
            width: "400px",
        },
        {
            name: "Institución",
            selector: (row) => row.Institucion,
            sortable: true,
            width: "400px",
        },
        {
            name: "Fecha Entrega",
            selector: (row) => new Date(row.FecElab).toLocaleDateString("es-ES", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            }),
            sortable: true,
            width: "400px",
        },
    ];

    // 📌 Función para generar JSON con la estructura correcta
    const generateJSON = () => {
        const payload = filteredOrders.map(order => ({
            "DocEntry": order.DocEntry,
            "DocumentLines": order.Orders.map(line => ({
                "DocEntry": line.DocEntry,
                "LineNum": line.LineNum,
                "ItemCode": line.Reemplazo,
                "Quantity": line.Quantity,
                "ProjectCode": line.Project,
            }))
        }));
        return payload;
    };

    // 📌 Enviar JSON al backend
    const sendDataToBackend = async () => {
        const payload = generateJSON();
        console.log(payload);
        try {
            const response = await apiClient.patch("/sales-orders/update-items", { orders: payload });
            
            const { results } = response.data;
                const successCount = results.filter(r => r.status === "success").length;
                const warningCount = results.filter(r => r.status === "warning").length;
                const errorCount = results.filter(r => r.status === "error").length;

                let messageText = "";
                if (successCount > 0) {
                    messageText += `${successCount} Ordenes actualizados con éxito.\n`;
                }
                if (warningCount > 0) {
                    messageText += `${warningCount} Ordenes sin cambios.\n`;
                }
                if (errorCount > 0) {
                    messageText += `${errorCount} errores en la actualización.\n`;
                }

            alert(messageText);
            // 🔹 Limpiar los campos después del envío exitoso
            setitemOld("");   // Resetea el select
            setitemNew("");     // Limpia el campo de texto
            setproject("");     // Limpia el campo de proyecto
            setFilteredOrders([]); // Borra la tabla de datos

        } catch (error) {
            console.error("Error al enviar los datos", error);
            alert("Error al enviar la solicitud.");
        }
    };

    return (
        <div className="container mt-4">
            <h2>Actualización de Articulos por Lineas</h2>

            {error && <div className="alert alert-danger">{error}</div>}
            <div className="row">
                <div className="col-md-3">
                    <label>Fecha Inicial:</label>
                    <input
                        type="date"
                        className="form-control"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                    />
                </div>
                <div className="col-md-3">
                    <label>Fecha Final:</label>
                    <input
                        type="date"
                        className="form-control"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                    />
                </div>
            </div>

            <div className="row">
                {/* Campo de Artículo Actual con lista desplegable con búsqueda */}
                <div className="col-md-3">
                    <label>Artículo Actual:</label>
                    <Select
                        options={items}
                        value={itemOld}
                        onChange={setitemOld}
                        placeholder="Seleccione un artículo..."
                        isSearchable={true}
                    />
                </div>
                <div className="col-md-3">
                    <label>Articulo Nuevo:</label>
                    <Select
                        options={items}
                        value={itemNew}
                        onChange={setitemNew}
                        placeholder="Seleccione un artículo..."
                        isSearchable={true}
                    />
                </div>
                <div className="col-md-3">
                    <label>Código de Proyecto:</label>
                    <Select
                        options={projects}
                        value={project}
                        onChange={setproject}
                        placeholder="Seleccione un proyecto..."
                        isSearchable={true}
                    />
                </div>
            </div>

            <button className="btn btn-success mt-2" onClick={fetchOrders}>Buscar</button>
            <button className="btn btn-primary mt-2 ml-2" onClick={sendDataToBackend}>Actualizar en SAP</button>
            <DataTable
                columns={columns}
                data={filteredOrders}
                expandableRows
                expandableRowsComponent={ExpandedComponent}
                pagination
            />
        </div>
    );
};

export default OrdersUpdateLines;
